import { useState } from "react";
import CarretDown from '../../Assets/AIOnDemand/carret-down.png';

const TurnkeyTabs = () => {
    const [activeItem, setActiveItem] = useState<number | null>(null)
    const isActive = (itemId: number) => itemId === activeItem
    const caseStudies = [
        {
            id: 0,
            title: 'Custom AI Solutions & Blueprint',
            subTitle: (
                <ul className="list-disc pl-4">
                    <li>Receive a clear blueprint detailing your AI-driven revenue roadmap.</li>
                    <li>Automate the exact sales and marketing tasks draining your team.</li>
                    <li>Gain a unique competitive edge with AI tailored to your market.</li>
                    <li>Build scalable AI solutions designed for your company’s future growth.</li>
                    <li>Address niche industry challenges using precisely targeted AI automation.</li>
                </ul>
            ),
        },
        {
            id: 1,
            title: 'AI Expert Teams',
            subTitle: (
                <ul className="list-disc pl-4">
                    <li>Leverage AI specialists focused exclusively on sales and marketing results.</li>
                    <li>Our expert team handles technical complexity minimizing your implementation risk.</li>
                    <li>Benefit from continuous workflow optimization ensuring peak performance over time.</li>
                    <li>Augment your team with dedicated AI experts without hiring burdens.</li>
                    <li>Access deep knowledge of the latest revenue-generating AI applications.</li>
                    <li>We translate your strategic business goals into effective AI workflows.</li>
                </ul>
            ),
        },
        {
            id: 2,
            title: 'Enterprise Sales Growth Experts',
            subTitle: (
                <ul className="list-disc pl-4">
                    <li>Implement proven methodologies that drive predictable revenue growth.</li>
                    <li>Apply expert strategies to dramatically boost sales team productivity.</li>
                    <li>Achieve significantly more accurate sales forecasts using expert techniques.</li>
                    <li>Optimize your entire sales cycle from lead acquisition to final close.</li>
                    <li>Utilize data-driven coaching methods proven to elevate rep performance.</li>
                    <li>Scale your sales outreach effectively while maintaining personalization quality.</li>
                </ul>
            ),
        },
        {
            id: 3,
            title: 'Tech, Tools and Data',
            subTitle: (
                <ul className="list-disc pl-4">
                    <li>Unlock the actionable revenue insights currently hidden within your data.</li>
                    <li>Enhance your existing tech stack performance with smart AI layers.</li>
                    <li>Eliminate tedious manual data entry burdening your valuable teams.</li>
                    <li>Deploy cutting-edge AI tools specifically curated for revenue impact.</li>
                    <li>Gain unified real-time visibility across your entire revenue funnel.</li>
                    <li>Make faster confident strategic decisions fueled by reliable AI insights.</li>
                </ul>
            ),
        },
        {
            id: 4,
            title: 'Integrations',
            subTitle: (
                <ul className="list-disc pl-4">
                    <li>Seamlessly integrate AI automation directly into your core revenue tools.</li>
                    <li>Eliminate frustrating data silos for complete funnel intelligence.</li>
                    <li>Maximize the return on your existing technology investments.</li>
                    <li>Experience faster AI deployment with minimal disruption to operations.</li>
                    <li>Effortlessly automate complex tasks across different software platforms.</li>
                    <li>Ensure data accuracy and consistency throughout your entire tech stack.</li>
                </ul>
            ),
        },
    ];

    return (
        <div className="lg:mt-16 flex items-start justify-center gap-20 px-2 lg:px-12">
            <section className="flex w-full flex-col gap-4">
                {caseStudies.map((item) => {
                    return (
                        <div key={item.id} className="w-full">
                            <div
                                onClick={() => {
                                    if (isActive(item.id)) {
                                        setActiveItem(null)
                                    } else {
                                        setActiveItem(item.id)
                                    }
                                }}
                                className={`flex cursor-pointer items-center gap-3 border-b border-black  p-2 px-4 `}
                            >
                                <p className="text-start text-[1rem]  font-bold text-black">
                                    {item.title}
                                </p>
                                <div className="flex items-center gap-4 px-2">
                                    <img
                                        alt="logo"
                                        src={CarretDown}
                                        className={`w-5 ${isActive(item.id) && 'rotate-180'} invert transition-all duration-300 ease-in`}
                                    />
                                </div>
                            </div>
                            <div
                                className={`grid overflow-hidden transition-all duration-300 ease-in-out ${isActive(item.id)
                                    ? 'mt-2 max-h-[500px] opacity-100'
                                    : 'max-h-0 opacity-0'
                                    }`}
                            >
                                <p className="px-4 py-2 text-black">
                                    {item.subTitle}
                                </p>
                            </div>
                        </div>
                    )
                })}
            </section>
        </div>
    );
}

export default TurnkeyTabs;